import { createFileRoute } from "@tanstack/react-router";

import { faqJsonLd } from "../components/tools/tool-layout";
import { OVULATION_COPY, OvulationView } from "../components/tools/weeks";
import { seo } from "../lib/head";

export const Route = createFileRoute("/calcul-ovulation")({
  staticData: { ssr: true },
  head: () =>
    seo({
      title: "Calcul de l'ovulation et de la période de fertilité · Listou",
      description:
        "Calculez vos prochaines dates d'ovulation et vos jours les plus fertiles à partir de vos dernières règles et de la durée de votre cycle.",
      jsonLd: faqJsonLd(OVULATION_COPY.faq),
    }),
  component: OvulationView,
});
